import { render, staticRenderFns } from "./WaiterTable.vue?vue&type=template&id=6b9c0ed8&scoped=true&lang=pug"
import script from "./WaiterTable.vue?vue&type=script&lang=ts"
export * from "./WaiterTable.vue?vue&type=script&lang=ts"
import style0 from "./WaiterTable.vue?vue&type=style&index=0&id=6b9c0ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c0ed8",
  null
  
)

export default component.exports